import React from "react";

const LeftRightImgContent = ({ section, columns = 3, align = "center" }) => {
  if (!section) return null;

  const { items = [] } = section;

  // width per card based on columns
  const basisClass =
    columns === 5
      ? "lg:basis-1/5"
      : columns === 4
        ? "lg:basis-1/4"
        : "lg:basis-1/3";

  return (
    <div className="flex flex-wrap justify-center gap-6">
      {items.map((item, index) => (
        <div
          key={item.id || index}
          className={`w-full 
        sm:basis-[calc(50%-0.75rem)] 
        md:basis-[calc(50%-0.75rem)] 
        ${columns === 5 ? "lg:basis-[calc(20%-1rem)]" : ""}
        ${columns === 4 ? "lg:basis-[calc(25%-1rem)]" : ""}
        ${columns === 3 ? "lg:basis-[calc(33.333%-1rem)]" : ""}
        flex justify-center
      `}
        >
          <ServiceCard item={item} align={align} />
        </div>
      ))}
    </div>
  );
};

export default LeftRightImgContent;

/* ── Card Component ── */

const ServiceCard = ({ item, align }) => {
  const textAlign =
    align === "left"
      ? "text-left items-start"
      : align === "right"
        ? "text-right items-end"
        : "text-center items-center";

  return (
    <div className="bg-white shadow-sm rounded-[10px] flex flex-col md:flex-row overflow-hidden w-full md:max-w-[420px]">
      {/* Image */}
      <div className="w-full md:w-1/2 h-[280px] md:h-auto">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover"
          draggable={false}
        />
      </div>

      {/* Content */}
      <div
        className={`w-full md:w-2/3 px-4 py-4 bg-[#EAF1FF] flex flex-col justify-center `}
      >
        <h3
          className="font-semibold mb-2 text-[14px] "
          style={{ color: "var(--primary-color)" }}
        >
          {item.title}
        </h3>

        <p
          className=" leading-relaxed"
          style={{ color: "var(--primary-color)" }}
        >
          {item.description}
        </p>
      </div>
    </div>
  );
};
